import * as React from 'react';
import {withTranslation} from 'react-i18next';
import i18next from 'i18next';
import ReportVehiclesStateManual from "components/Raports/ReportsComposites/ReportVehiclesStateManual";
import VehiclesStateReportPresent from "components/Raports/ReportsComposites/VehiclesStateReportPresent";

type P = {
    t?: i18next.TFunction;
};
type S = {
    //
};

class VehiclesStateReport extends React.Component<P, S> {
    public render() {
        const {t} = this.props;
        return (
            <div className="main__content">
                <h3 className="main__title">{t('vehiclesStateReport')}</h3>
                <div className="flex flex--wrap">
                    <div className="main__inner-left">
                        <ReportVehiclesStateManual/>
                    </div>
                    <div className="main__inner-right main__inner-right--flex-4">
                        <VehiclesStateReportPresent/>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('reports')(VehiclesStateReport as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Raports/VehiclesStateReport.tsx